import { useState, useEffect } from "react";
import LoaderWithBackdrop from "../../loader/LoaderWithBackdrop";

function ThreeImagesPreview({
  imagesList,
  maxHeight,
  checkImagesWiderThanTall,
  imageTag,
}) {
  const [widerImage, setWiderImage] = useState(null);

  useEffect(() => {
    const checkImages = async () => {
      const result = await checkImagesWiderThanTall(1);
      setWiderImage(result);
    };

    checkImages();
  }, [imagesList]);

  // Helper function to generate common styles
  const getImageStyle = (
    heightDivide,
    heightSub,
    width,
    padding = false,
    borderRadius = {}
  ) => ({
    height: `calc((${maxHeight} / ${heightDivide}) - ${heightSub}px)`,
    width: width ? `calc(${width} - 2px)` : "",
    borderTopLeftRadius: borderRadius.topLeft || "inherit",
    borderTopRightRadius: borderRadius.topRight || "inherit",
    borderBottomLeftRadius: borderRadius.bottomLeft || "inherit",
    borderBottomRightRadius: borderRadius.bottomRight || "inherit",
    padding: padding ? "2px" : "",
  });

  if (widerImage === null) {
    return (
      <div style={{ position: "relative", height: `calc(${maxHeight} / 2)` }}>
        <LoaderWithBackdrop isAbsolute={true} />
      </div>
    );
  }

  return (
    <div className="row m-0" style={{ borderRadius: "inherit", maxHeight }}>
      {widerImage ? (
        <>
          <div
            className="col-12 px-0"
            style={getImageStyle(2, 4, null, true, {
              topLeft: "inherit",
              topRight: "inherit",
              bottomLeft: "0",
              bottomRight: "0",
            })}
          >
            <div style={getImageStyle(2, 8, null)}>
              {imageTag(imagesList[0], 0)}
            </div>
          </div>

          <div
            className="col-12 px-0 d-flex justify-content-between"
            style={getImageStyle(2, 4, null, true, {
              topLeft: "0",
              topRight: "0",
              bottomLeft: "inherit",
              bottomRight: "inherit",
            })}
          >
            <div
              style={getImageStyle(2, 8, "50%", false, {
                topLeft: "0",
                topRight: "0",
                bottomLeft: "inherit",
                bottomRight: "0",
              })}
            >
              {imageTag(imagesList[1], 1)}
            </div>
            <div
              style={getImageStyle(2, 8, "50%", false, {
                topLeft: "0",
                topRight: "0",
                bottomLeft: "0",
                bottomRight: "inherit",
              })}
            >
              {imageTag(imagesList[2], 2)}
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className="col-6 ps-0"
            style={getImageStyle(1, 4, null, true, {
              topLeft: "inherit",
              topRight: "0",
              bottomLeft: "inherit",
              bottomRight: "0",
            })}
          >
            <div style={getImageStyle(1, 8, null)}>
              {imageTag(imagesList[0], 0)}
            </div>
          </div>

          <div
            className="col-6  d-flex flex-column justify-content-between pe-0"
            style={getImageStyle(1, 4, null, true, {
              topLeft: "0",
              topRight: "inherit",
              bottomLeft: "0",
              bottomRight: "inherit",
            })}
          >
            <div
              style={getImageStyle(2, 6, null, false, {
                topLeft: "0",
                topRight: "inherit",
                bottomLeft: "0",
                bottomRight: "0",
              })}
            >
              {imageTag(imagesList[1], 1)}
            </div>
            <div
              style={getImageStyle(2, 6, null, false, {
                topLeft: "0",
                topRight: "0",
                bottomLeft: "0",
                bottomRight: "inherit",
              })}
            >
              {imageTag(imagesList[2], 2)}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default ThreeImagesPreview;
